import React from "react";
import PropTypes from "prop-types";
import ClickAwayListener from "react-click-away-listener";
import { InfoTooltip } from "./InfoTooltip";
import { ErrorTooltip } from "./ErrorTooltip";
import { PlainTooltip } from "@learningblocks/storybook-components/lib/Tooltip/PlainTooltip";
import "./style.scss";

const ALERT_TYPE = { FAIL: "FAIL", INFO: "INFO", PLAIN: "PLAIN" };

/**
 * Tooltip Component:
 *  - Typically used to display error messages.
 */
export class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      clicked: false,
    };
  }

  onHover = (value) => () => this.setState({ hover: value });
  onClick = (value) => () => this.setState({ clicked: value });

  closeTooltip = () =>
    this.setState({
      hover: false,
      clicked: false,
    });

  renderTooltip = () => {
    switch (this.props.type) {
      case ALERT_TYPE.FAIL:
        return (
          <ErrorTooltip
            title={this.props.title}
            className={
              this.props.direction ? `tooltip-${this.props.direction}` : ""
            }
          />
        );
      case ALERT_TYPE.INFO:
        return (
          <InfoTooltip
            title={this.props.title}
            className={
              this.props.direction ? `tooltip-${this.props.direction}` : ""
            }
          />
        );
      case ALERT_TYPE.PLAIN:
        return (
          <PlainTooltip
            title={this.props.title}
            className={`${
              this.props.direction ? `tooltip-${this.props.direction}` : ""
            } } ${this.props.className || ""}`}
          />
        );
      default:
        return null;
    }
  };

  renderContent = () => {
    return (
      <div
        style={{
          display:
            this.props.show ||
            ((this.state.hover || this.state.clicked) && this.props.title)
              ? "initial"
              : "none",
        }}
      >
        {this.renderTooltip()}
      </div>
    );
  };

  render() {
    const className = `tooltip-wrap ${this.props.className}`;
    return (
      <ClickAwayListener onClickAway={this.closeTooltip}>
        <button
          className={className}
          onClick={this.onClick(!this.state.clicked)}
          onFocus={this.onHover(true)}
          onBlur={this.onHover(false)}
          onMouseOver={this.onHover(true)}
          onMouseOut={this.onHover(false)}
        >
          {this.props.children}
          {this.renderContent()}
        </button>
      </ClickAwayListener>
    );
  }
}

Tooltip.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * direction of the tooltip
   */
  direction: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  /**
   * Child element to be displayed inside the Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Title string for the Modal.
   */
  title: PropTypes.string,
  /**
   * Status of Streak Unit
   */
  type: PropTypes.oneOf([ALERT_TYPE.FAIL, ALERT_TYPE.INFO]),
  /**
   * Override for default hover behaviour
   * is show is set tooltip will always be displayed
   */
  show: PropTypes.bool,
};

Tooltip.defaultProps = {
  title: "",
  type: "FAIL",
  show: false,
  className: "",
  direction: "left",
};
